import { Button } from "@/components/ui/button";
import { Link } from "wouter";

const Hero = () => {
  return (
    <section id="home" className="gradient-bg text-white">
      <div className="container mx-auto px-4 py-20">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Transform Your Data Into <span className="text-emerald-500">Strategic Decisions</span>
            </h1>
            <p className="text-xl mb-8">
              Advanced analytics and AI solutions tailored for DTC, eCommerce, and BioScience companies.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link href="/contact">
                <Button size="lg" className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700">
                  Get in Touch
                </Button>
              </Link>
              <a href="#services">
                <Button variant="outline" size="lg" className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700">
                  Explore Services
                </Button>
              </a>
            </div>
          </div>
          <div className="md:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600" 
              alt="Data visualization concept" 
              className="rounded-lg shadow-xl" 
              width="800" 
              height="600"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
